// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Nav from "../../resources/navigation/Nav.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as StockTransferForm from "./StockTransferForm.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageBottomActionsBar from "../../resources/layout-and-structure/PageBottomActionsBar.res.js";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as StockTransferFormActions from "./StockTransferFormActions.res.js";
import * as StockTransferFormProducts from "./StockTransferFormProducts.res.js";
import * as LegacyProductReferenceTableCell from "../Product/LegacyProductReferenceTableCell.res.js";
import * as StockTransferFormProductPickerModalTable from "./StockTransferFormProductPickerModalTable.res.js";
let style = {
  style: {
    backgroundColor: "#f8f8fb",
    borderBottomColor: "#e7e7ee",
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    paddingBlock: "23px"
  }
};
let make = React.memo(props => {
  let errorMessage = props.errorMessage;
  let newrecord = {
    ...style
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(TextStyle.make, {
    children: props.message,
    variation: "normal",
    size: "small"
  }), errorMessage !== undefined ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: errorMessage,
      variation: "negative",
      size: "xsmall"
    }),
    spaceTop: "xsmall"
  }) : null], newrecord));
});
let TablePlaceholder = {
  style: style,
  make: make
};
function keyExtractor(row) {
  return row.senderVariantId;
}
let Row = {
  keyExtractor: keyExtractor
};
function tableColumns(dispatch) {
  return [{
    key: "reference",
    name: I18n.t("Product"),
    render: param => {
      let product = param.data;
      return JsxRuntime.jsx(LegacyProductReferenceTableCell.make, {
        id: product.senderVariantId,
        name: product.name,
        description: product.description,
        errorMessage: param.errorMessage,
        openNewTab: true
      });
    }
  }, {
    key: "senderStock",
    name: I18n.t("Sender stock"),
    render: param => {
      let product = param.data;
      return JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(ProductStockTableCell.make, {
          value: product.senderStockQuantity.toString(),
          state: product.senderStockState,
          size: "xsmall"
        }),
        spaceLeft: "normal"
      });
    }
  }, {
    key: "recipientStock",
    name: I18n.t("Recipient stock"),
    render: param => {
      let product = param.data;
      let quantity = product.recipientStockQuantity;
      return JsxRuntime.jsx(Box.make, {
        children: quantity !== undefined ? JsxRuntime.jsx(ProductStockTableCell.make, {
          value: quantity.toString(),
          state: product.recipientStockState,
          size: "xsmall"
        }) : JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("—"),
          variation: "normal"
        }),
        spaceLeft: "normal"
      });
    }
  }, {
    key: "transferredQuantity",
    name: I18n.t("Transferred quantity"),
    render: param => {
      let product = param.data;
      return JsxRuntime.jsx(InputNumberField.make, {
        value: product.transferredQuantity,
        minValue: 1,
        precision: 0,
        onChange: quantity => dispatch({
          TAG: "ProductTransferredQuantityUpdateRequested",
          _0: product.cku,
          _1: quantity | 0
        })
      });
    }
  }, {
    key: "actions",
    layout: {
      alignX: "flexEnd"
    },
    render: param => {
      let product = param.data;
      return JsxRuntime.jsx(Button.make, {
        shape: "pill",
        icon: "delete",
        onPress: () => dispatch({
          TAG: "ProductRemoveRequested",
          _0: product.cku
        })
      });
    }
  }];
}
function StockTransferFormProductsCard(props) {
  let match = Nav.Context.use();
  let match$1 = StockTransferFormProducts.use();
  let productsDispatch = match$1[1];
  let productsState = match$1[0];
  let match$2 = React.useState(() => false);
  let setPickerOpened = match$2[1];
  let formState = StockTransferForm.useFormState();
  let notifier = Notifier.use(undefined, undefined);
  let match$3 = React.useMemo(() => Belt_Array.partition(productsState.products, product => Stdlib_Option.isSome(product.recipientStockQuantity)), [productsState.products]);
  let nonCommonProducts = match$3[1];
  let senderShopId = formState.values.senderShopId;
  let recipientShopId = formState.values.recipientShopId;
  React.useEffect(() => {
    let nonCommonProductsLength = nonCommonProducts.length;
    if (!productsState.processing && nonCommonProductsLength > 0) {
      notifier.reset({
        TAG: "Warning",
        _0: I18n.template(I18n.t(I18n.isPlural(nonCommonProductsLength) ? "{{count}} products could not be added to the transfer because they are not common to the two selected shops." : "{{count}} product could not be added to the transfer because it is not common to the two selected shops."), {
          count: nonCommonProductsLength
        }, undefined)
      }, nonCommonProducts.map(product => product.name + Stdlib_Option.mapOr(product.stockKeepingUnit, "", sku => ", " + sku)), undefined);
      nonCommonProducts.forEach(product => productsDispatch({
        TAG: "ProductRemoveRequested",
        _0: product.cku
      }));
    }
    if (!productsState.processing && nonCommonProductsLength === 0) {
      notifier.clear();
    }
  }, [productsState.processing]);
  React.useEffect(() => {
    if (formState.values.products.length !== 0) {
      productsDispatch("ResetRequested");
      notifier.clear();
    }
  }, [senderShopId, recipientShopId]);
  let renderActionsStart = () => JsxRuntime.jsx(Button.make, {
    label: I18n.t("Search product"),
    variant: {
      NAME: "ghost",
      VAL: {
        bordered: true
      }
    },
    tone: "brand",
    disabled: productsState.processing || senderShopId === "" || recipientShopId === "",
    icon: "search",
    tooltipText: senderShopId === "" || recipientShopId === "" ? I18n.t("Please select the shops linked to the transfer to start adding products.") : undefined,
    onPress: () => setPickerOpened(param => true)
  });
  let renderActionsEnd = () => JsxRuntime.jsx(StockTransferFormActions.make, {});
  let columns = tableColumns(productsDispatch);
  let errors = formState.validation;
  let productsError;
  productsError = errors.TAG === "Ok" ? undefined : Stdlib_Array.filterMap(errors._0, param => {
    switch (param[0]._0) {
      case "SenderShopId":
      case "RecipientShopId":
        return;
      case "Products":
        return param[1];
    }
  })[0];
  let match$4 = formState.submission;
  let tmp;
  tmp = productsError !== undefined && typeof match$4 === "object" && match$4.TAG === "Failed" ? I18n.t(productsError) : undefined;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(Card.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(Button.make, {
            label: I18n.t("Search product"),
            variant: {
              NAME: "ghost",
              VAL: {
                bordered: true
              }
            },
            tone: "brand",
            disabled: productsState.processing || senderShopId === "" || recipientShopId === "",
            icon: "search",
            tooltipText: senderShopId === "" || recipientShopId === "" ? I18n.t("Please select the shops linked to the transfer to start adding products.") : undefined,
            onPress: () => setPickerOpened(param => true)
          }),
          grow: false
        }),
        spaceX: "large",
        spaceBottom: "xlarge"
      }), JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: match$3[0]
          }
        },
        columns: columns,
        keyExtractor: keyExtractor,
        erroredRowsMap: props.productsRowErrors,
        placeholderEmptyState: JsxRuntime.jsx(make, {
          message: I18n.t("Add products to complete your transfer"),
          errorMessage: tmp
        })
      })],
      variation: "table"
    }), JsxRuntime.jsx(StockTransferFormProductPickerModalTable.make, {
      opened: match$2[0],
      senderShopId: senderShopId,
      recipientShopId: recipientShopId,
      disabledIds: productsState.products.map(product => product.senderVariantId),
      onCommit: products => productsDispatch({
        TAG: "ProductBulkAddRequested",
        _0: products
      }),
      onRequestClose: () => setPickerOpened(param => false)
    }), JsxRuntime.jsx(SpinnerModal.make, {
      title: I18n.t("Loading products"),
      opened: productsState.processing
    }), JsxRuntime.jsx(PageBottomActionsBar.make, {
      displayThreshold: 180,
      renderStart: renderActionsStart,
      renderEnd: renderActionsEnd,
      navOpened: match[0].opened
    })]
  });
}
let make$1 = React.memo(StockTransferFormProductsCard);
export { TablePlaceholder, Row, tableColumns, make$1 as make };
/* style Not a pure module */